/**
 * A search result is authoritative only for its own committed payload key.
 * React Query must not project data from the previous key while the next
 * committed search is loading (or after the committed payload is cleared).
 */
export function verticalSearchAuthorityOptions(hasCommittedPayload: boolean) {
  return {
    enabled: hasCommittedPayload,
    keepPreviousData: false,
  } as const;
}
